import React from 'react'
import styled from 'styled-components';
import ReactGA from 'react-ga';
import Jumbotron from '../components/Jumbotron';
import { MdCall, MdMailOutline} from "react-icons/md";


const Container = styled.div`
    /* width: 70%;
    margin: 0 auto; */
    max-width: 1200px;
    padding: 3em 0 3em 0;

    * {
        box-sizing: border-box;
    }
`;

const AdditionalContactInfo = styled.div`
    /* width: 70%;
    margin: 0 auto; */
    padding: 3em 0 3em 0;

    .wrapper {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: space-between;
        height: 100%;

        @media(max-width: 500px) {
            align-items: center;
        }
 
        .center {
            display: flex;
            align-items: center;
            padding-bottom: 25px;

            @media(max-width: 500px) {
                flex-direction: column;
                padding-bottom: 50px;
            }

            * {
                margin-right: 20px;
                @media(max-width: 500px) {
                    margin-right: 0;
                }
            }

            a {
                color: #212529;
                font-size: 18px;
                font-weight: bold;
                @media(max-width: 500px) {
                    font-size: 21px;
                }
            }
        }

        svg {
            font-size: 30px;
            @media(max-width: 500px) {
                font-size: 35px;
                margin-bottom: 25px;
            }
        }
    }
`;

const ListWrapper = styled.div`
    list-style-type: none;
    padding: 0;
    max-width: 800px;
    margin: 0 auto;

    li {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        @media(max-width: 500px) {
            flex-direction: column;
        }

        &:not(:last-child) {
            margin-bottom: 20px;
        }

        label {
            flex: 1;
            max-width: 220px;
            padding: 8px;
            font-weight: 300;
            letter-spacing: .09em;
            text-transform: uppercase;

            + * {
                flex: 1;

                @media(max-width: 500px) {
                    width: 100%;
                }
            }
        }

        input:not([type='checkbox']),
        textarea {
            padding: 15px;
            /* border: none; */
        }

        input:focus,
        textarea:focus {
            /* outline: none; */
        }

        button {
            margin-left: auto;
            padding: 8px 16px;
            border: none;
            background: #333;
            color: #f2f2f2;
            text-transform: uppercase;
            letter-spacing: .09em;
            border-radius: 2px;

            &:hover {
                background-color: #009eff9c;
                cursor: pointer;
            }

            @media(max-width: 500px) {
                margin-left: inherit;
            }
        }
    }
`;

const clickedToEmail = () => {
    ReactGA.event({
        category: 'Contact',
        action: 'Clicked to email business address'
    });
}

const clickedMobileNum = () => {
    ReactGA.event({
        category: 'Contact',
        action: 'Clicked to call business number'
    });
}

const Contact = () => (
  <div style={{maxWidth: '100%'}}>
    <Jumbotron title='Contact' subtext='Number of ways to reach us'/>
    <div className="p-5">
        <div className="row">
            <div className="col-12 col-sm-8">
                <Container>
                    <div style={{paddingBottom: '40px'}}>
                        <h2>Get in Touch</h2>
                        <h5 className="text-muted">Please fill out the quick form and we will be in touch soon.</h5>
                    </div>
                    <form name="calmel-contact-form" subject="CalMel-Designs" method="post" data-netlify="true" data-netlify-honeypot="bot-field">
                        <p hidden>
                            <label>Don’t fill this out if you're human: <input type="hidden" name="form-name" value="calmel-contact-form"/></label>
                        </p>
                        <ListWrapper>
                            <li>
                                <label htmlFor="fullname">Name</label>
                                <input type="text" name="fullname" placeholder="Enter your name" required/>
                            </li>
                            <li>
                                <label htmlFor="email">Email</label>
                                <input type="email" name="email" placeholder="Enter your email" required/>
                            </li>
                            <li>
                                <label htmlFor="phone">Phone</label>
                                <input type="tel" name="phone" placeholder="Enter your phone"/>
                            </li>
                            <li>
                                <label htmlFor="service-type">Choose a service:</label>
                                <select name="service-type" required>
                                    <option value="">--Please choose an option--</option>
                                    <option value="Drafting and Design">Drafting & Design</option>
                                    <option value="Shop drawings">Shop drawings</option>
                                    <option value="Field Measuring">Field Measuring</option>
                                    <option value="3D Modeling and Rendering">3D Modeling & Rendering</option>
                                    <option value="Other">Other</option>
                                </select>
                            </li>
                            <li>
                                <label htmlFor="message">Message</label>
                                <textarea rows="6" name="message" placeholder="Enter your message here"></textarea>
                            </li>
                            <li>
                                <button type="submit">Submit</button>
                            </li>
                        </ListWrapper>
                    </form>
                </Container>
            </div>
            <div className="col-12 col-sm-4">
                <AdditionalContactInfo>
                    <div style={{paddingBottom: '40px'}}>
                        <h3>Other Contact Options</h3>
                        <h5 className="text-muted">Feel free to also reach us via email/phone.</h5>
                    </div>
                    <div className="wrapper">
                        <div className="center">
                            <MdMailOutline />
                            <div><a href="mailto:info@calmeldesigns.com?subject=Calmel Inquiry" onClick={clickedToEmail}>info@calmeldesigns.com</a></div>
                        </div>
                        <div className="center">
                            <MdCall />
                            <div><a href="tel:+18184793840" onClick={clickedMobileNum}>(818) 479-3840</a></div>
                        </div>
                    </div>
                </AdditionalContactInfo>
            </div>
        </div>
    </div>
  </div>
)

export default Contact;



// WEBPACK FOOTER //
// ./src/views/Contact.js